import type { TrackingEvent } from "./trackingEvents/TrackingEvent";
import type { TrackingEvents } from "./trackingEvents/types";

import type { StandardData } from "./events";

export type GetAllNoArgumentsFunctionsNames<T> = {
  [K in keyof T]: T[K] extends () => Promise<StandardData> ? K : never;
}[keyof T];

export const addTrackingEventListener = <TrackingEventName extends TrackingEvents>(
  name: TrackingEventName,
  callback: (data: TrackingEvent<TrackingEventName>) => void
) => {
  document.addEventListener(name, callback);
};

export const GTMScript = (code = "GTM-57WFMN3") => {
  const element = document.createElement("script");
  element.innerHTML = `(function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', "${code}");`;

  return element;
};

export const GTMNoScript = (code: string) => {
  const element = document.createElement("noscript");
  element.innerHTML = `<iframe src="//www.googletagmanager.com/ns.html?id=${code}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

  return element;
};
